import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=c4fcceae&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&"
import style1 from "./NotificationItem.vue?vue&type=style&index=1&id=c4fcceae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fcceae",
  null
  
)

export default component.exports